import * as React from "react";

import { StyleRules, Theme, withStyles } from "@material-ui/core/styles";
import { WithStyles } from "@material-ui/core/styles/withStyles";

type ClassNames = "container";

const styles = (theme: Theme): StyleRules<ClassNames> => ({
    container: {}
});

interface ICoffeeIconProps extends WithStyles<typeof styles> {}

class CoffeeIcon extends React.PureComponent<ICoffeeIconProps> {
    public render() {
        const theme = this.props.theme as Theme;
        const primary1 = theme.palette.primary[500];
        const primary2 = theme.palette.primary[600];
        return (
            <svg width={274} height={288}>
                <g fill="none" fillRule="evenodd">
                    <path
                        d="M170.868 287.596c-43.554 0-80.04-6.804-89.613-15.946-44.669-1.425-79.024-10.062-79.024-20.506 0-5.565 9.753-10.618 25.625-14.339.019.153.037.273.057.372 2.871 15.942 21.828 18.967 55.802 18.967 22.949 0 38.632-1.286 47.497-6.814 14.944 13.951 35.009 22.49 57.068 22.49 19.838 0 38.06-6.903 52.398-18.442 13.87 3.626 22.256 8.344 22.256 13.504 0 11.441-41.219 20.714-92.066 20.714"
                        fill="#FAFAFA"
                    />
                    <path
                        d="M160.128 25.405H7.297S29.35 235.498 29.382 235.861l.123.986c2.551 14.337 19.036 17.672 54.21 17.672 34.91 0 51.223-3.166 54.143-17.353.174-.22 22.27-211.761 22.27-211.761"
                        fill="#FAF9DA"
                    />
                    <path
                        d="M31.097 236.519l.007.046c2.173 12.211 15.446 16.324 52.611 16.324 37.261 0 50.038-3.893 52.547-16.032.554-3.98 19.937-189.457 22.064-209.822H9.101c2.987 28.473 21.842 208.082 21.901 208.68 0 0 .063.599.095.804m52.618 19.625c-33.974 0-52.931-3.025-55.802-18.967-.044-.223-.08-.553-.147-1.139-.107-1.086-21.864-208.361-22.085-210.464a1.63 1.63 0 0 1 1.616-1.792h152.831a1.625 1.625 0 0 1 1.614 1.792c-19.162 183.451-21.78 208.216-22.407 211.897l.113.028c-3.243 15.753-21.317 18.645-55.733 18.645"
                        fill="#212121"
                        fillRule="nonzero"
                    />
                    <path
                        d="M50.813 39.973c.029 45.925-2.085 100.248 22.024 141.331 11.418 19.459 15.833 34.403 38.051 40.444 7.137 1.928 14.337 3.146 21.578 3.807 2.922-61.266 21.381-194.579 21.381-194.579H49.657a35.284 35.284 0 0 1 1.156 8.997"
                        fill="#FAFAE5"
                    />
                    <path
                        fill={primary1}
                        d="M10.278 89.432l7.387 86.057h130.441l9.039-86.057H10.278"
                    />
                    <path
                        d="M19.154 173.867h127.488l8.7-82.809H12.05l7.104 82.809m128.952 3.25H17.665c-.842 0-1.549-.65-1.618-1.49L8.661 89.574a1.635 1.635 0 0 1 .42-1.242 1.65 1.65 0 0 1 1.197-.522h146.867c.459 0 .902.194 1.208.538.308.345.456.801.408 1.256l-9.04 86.052a1.627 1.627 0 0 1-1.615 1.461"
                        fill="#212121"
                        fillRule="nonzero"
                    />
                    <path
                        d="M83.715 254.519c25.231 0 37.714-2.366 46.162-6.463l.101.099c-8.345 4.991-23.27 6.364-46.263 6.364m42.82-6.374c.82-.356 1.579-.734 2.286-1.137.343.347.69.692 1.04 1.033-1.117.052-2.227.087-3.326.104"
                        fill="#3A2623"
                        fillRule="nonzero"
                    />
                    <path
                        d="M40.268 27.035H27.885c.073-.548.157-1.091.248-1.63H7.297h33.151a43.898 43.898 0 0 0-.18 1.63"
                        fill="#3A2623"
                    />
                    <path
                        d="M29.382 235.861c-.012-.18-1.729-26.953-5.937-58.744h.024c4.242 30.6 5.901 58.564 5.913 58.744M13.845 87.81c-3.677-35.014-6.548-62.405-6.548-62.405s2.806 26.715 6.548 62.405M23.469 177.117h-.024c-.103-.777-.208-1.563-.314-2.346l.009.002c.111.783.221 1.564.329 2.344M14.015 89.432l-.17-1.622.17 1.622"
                        fill="#3A2623"
                        fillRule="nonzero"
                    />
                    <path
                        d="M83.715 254.519c-35.174 0-51.659-3.335-54.21-17.672l-.123-.986c-.012-.18-1.671-28.144-5.913-58.744h1.384c3.472 33.074 6.127 58.374 6.149 58.598 0 0 .063.599.095.804l.007.046c2.173 12.211 15.446 16.324 52.611 16.324 21.539 0 34.898-1.302 42.82-4.744 1.099-.017 2.209-.052 3.326-.104l.016.015c-8.448 4.097-20.931 6.463-46.162 6.463M15.48 87.81h-1.635c-3.742-35.69-6.548-62.405-6.548-62.405h20.836a47.324 47.324 0 0 0-.248 1.63H9.101L15.48 87.81M37.432 177.117H23.469c-.108-.78-.218-1.561-.329-2.344l-.009-.002a62.182 62.182 0 0 0-.058-.426l-4.124-.271v-.002c-.033-.328-4.979-49.197-7.991-78.139l-.68-6.501h3.737l-.17-1.622h12.897c.021 1.083.045 2.165.072 3.248H12.05l7.104 82.809h17.375c.29 1.088.59 2.17.903 3.25"
                        fill="#35221F"
                    />
                    <path
                        d="M165.802 42.601c0 4.855-36.748 8.791-82.092 8.791-45.335 0-82.087-3.936-82.087-8.791V27.465c11.813-3.299 47.098 6.355 82.087 6.355 29.55 0 67.634-9.191 82.092-6.683v15.464"
                        fill={primary2}
                    />
                    <path
                        d="M3.248 28.763v13.838c1.945 2.772 31.779 7.169 80.462 7.169 48.686 0 78.521-4.397 80.528-7.43l-.054-13.793c-7.151-.816-20.641.886-34.959 2.788-14.573 1.922-31.09 4.11-45.515 4.11-17.479 0-35.313-2.434-49.637-4.382-13.667-1.865-25.148-3.309-30.825-2.3zM83.71 53.018C80.293 53.018 0 52.905 0 42.601V27.465c0-.732.483-1.362 1.184-1.566 5.852-1.615 18.07-.139 33.33 1.934 14.229 1.943 31.938 4.362 49.196 4.362 14.212 0 30.615-2.173 45.091-4.09 15.64-2.055 30.057-3.821 37.28-2.568a1.627 1.627 0 0 1 1.346 1.6v15.464c0 10.304-80.298 10.417-83.717 10.417z"
                        fill="#212121"
                        fillRule="nonzero"
                    />
                    <path
                        d="M165.802 27.137c0 4.853-36.748 8.781-82.092 8.781-45.335 0-82.087-3.928-82.087-8.781 0-4.857 36.752-8.791 82.087-8.791 45.344 0 82.092 3.934 82.092 8.791"
                        fill={primary2}
                    />
                    <path
                        d="M3.427 27.137c3.502 3.021 33.001 7.161 80.283 7.161 47.287 0 76.786-4.14 80.29-7.161-3.504-3.022-33.003-7.168-80.29-7.168-47.279 0-76.781 4.146-80.283 7.168zM83.71 37.549C80.293 37.549 0 37.434 0 27.137c0-10.304 80.293-10.414 83.71-10.414 3.419 0 83.717.11 83.717 10.414 0 10.297-80.298 10.412-83.717 10.412z"
                        fill="#212121"
                        fillRule="nonzero"
                    />
                    <path
                        d="M157.914 23.37c0 4.356-32.942 7.875-73.575 7.875-40.627 0-73.564-3.519-73.564-7.875V9.805c10.585-2.958 42.204 5.687 73.564 5.687 26.487 0 60.616-8.239 73.575-5.986V23.37"
                        fill={primary2}
                    />
                    <path
                        d="M12.397 11.108V23.37c1.961 2.426 28.128 6.253 71.942 6.253 43.819 0 69.992-3.827 72.037-6.588l-.077-12.109c-6.394-.688-18.428.819-31.154 2.506-13.062 1.728-27.868 3.686-40.806 3.686-15.671 0-31.649-2.184-44.485-3.929-12.136-1.654-22.345-2.928-27.457-2.081zm71.942 21.765c-7.699 0-75.19-.269-75.19-9.503V9.805c0-.722.485-1.364 1.188-1.569 5.278-1.458 16.245-.13 29.955 1.733 12.738 1.733 28.597 3.9 44.047 3.9 12.722 0 27.419-1.947 40.382-3.654 14.041-1.858 26.97-3.432 33.471-2.306a1.627 1.627 0 0 1 1.347 1.597V23.37c0 9.234-67.504 9.503-75.2 9.503z"
                        fill="#212121"
                        fillRule="nonzero"
                    />
                    <path
                        d="M157.914 9.506c0 4.353-32.942 7.883-73.575 7.883-40.627 0-73.564-3.53-73.564-7.883 0-4.354 32.937-7.881 73.564-7.881 40.633 0 73.575 3.527 73.575 7.881"
                        fill={primary2}
                    />
                    <path
                        d="M12.672 9.506c3.798 2.728 29.601 6.258 71.667 6.258 42.074 0 67.878-3.53 71.678-6.258-3.795-2.728-29.602-6.258-71.678-6.258-42.076 0-67.874 3.53-71.667 6.258zm71.667 9.505c-7.699 0-75.19-.266-75.19-9.505S76.64 0 84.339 0c7.696 0 75.2.267 75.2 9.506s-67.504 9.505-75.2 9.505z"
                        fill="#212121"
                        fillRule="nonzero"
                    />
                    <path
                        d="M57.025 123.521c0-6.898-5.587-12.475-12.482-12.475-6.898 0-12.48 5.577-12.48 12.475 0 6.889 5.582 12.485 12.48 12.485 6.895 0 12.482-5.596 12.482-12.485"
                        fill="#402A27"
                    />
                    <path
                        d="M48.92 121.373a3.982 3.982 0 0 1 0-7.961 3.98 3.98 0 0 1 0 7.961"
                        fill="#F1F0EB"
                    />
                    <path
                        d="M53.524 119.907c-.898 1.635-2.616 2.759-4.604 2.759-2.905 0-5.275-2.373-5.275-5.277a5.22 5.22 0 0 1 1.384-3.522c-.163-.015-.319-.036-.486-.036-5.349 0-9.685 4.341-9.685 9.69 0 5.354 4.336 9.69 9.685 9.69s9.687-4.336 9.687-9.69a9.683 9.683 0 0 0-.706-3.614"
                        fill="#000"
                    />
                    <path
                        d="M46.67 122.16a5.317 5.317 0 0 1-1.871-1.484c.888.049 1.631.66 1.871 1.484"
                        fill="#6B534D"
                    />
                    <path
                        d="M44.681 124.813a2.073 2.073 0 0 1-2.073-2.078 2.068 2.068 0 0 1 2.191-2.059c.5.626 1.14 1.137 1.871 1.484a2.074 2.074 0 0 1-1.989 2.653"
                        fillOpacity={0.5}
                        fill="#FFF"
                    />
                    <path
                        d="M51.184 140.31c0 2.378-5.102 4.298-11.391 4.298-6.299 0-11.402-1.92-11.402-4.298 0-2.372 5.103-4.304 11.402-4.304 6.289 0 11.391 1.932 11.391 4.304"
                        fill="#ED9A79"
                    />
                    <path
                        d="M132.995 123.521c0-6.898-5.589-12.475-12.486-12.475-6.888 0-12.48 5.577-12.48 12.475 0 6.889 5.592 12.485 12.48 12.485 6.897 0 12.486-5.596 12.486-12.485"
                        fill="#402A27"
                    />
                    <path
                        d="M124.888 121.373a3.987 3.987 0 0 1-3.983-3.984 3.985 3.985 0 0 1 3.983-3.977 3.98 3.98 0 0 1 0 7.961"
                        fill="#F1F0EB"
                    />
                    <path
                        d="M129.489 119.907c-.898 1.635-2.61 2.759-4.601 2.759-2.908 0-5.273-2.373-5.273-5.277a5.2 5.2 0 0 1 1.382-3.522c-.158-.015-.319-.036-.488-.036-5.35 0-9.68 4.341-9.68 9.69 0 5.354 4.33 9.69 9.68 9.69 5.353 0 9.686-4.336 9.686-9.69a9.763 9.763 0 0 0-.706-3.614"
                        fill="#000"
                    />
                    <path
                        d="M122.635 122.159a5.313 5.313 0 0 1-1.868-1.483c.889.051 1.629.66 1.868 1.483"
                        fill="#6B534D"
                    />
                    <path
                        d="M120.646 124.813a2.07 2.07 0 0 1-2.07-2.078 2.066 2.066 0 0 1 2.191-2.059 5.313 5.313 0 0 0 1.868 1.483 2.072 2.072 0 0 1-1.989 2.654"
                        fillOpacity={0.5}
                        fill="#FFF"
                    />
                    <path
                        d="M139.028 140.31c0 2.378-5.101 4.298-11.397 4.298s-11.395-1.92-11.395-4.298c0-2.372 5.099-4.304 11.395-4.304 6.296 0 11.397 1.932 11.397 4.304"
                        fill="#ED9A79"
                    />
                    <path
                        d="M83.71 147.313c-7.779 0-14.108-6.327-14.108-14.102a1.627 1.627 0 0 1 3.253 0c0 5.989 4.866 10.857 10.855 10.857 5.988 0 10.859-4.868 10.859-10.857a1.624 1.624 0 1 1 3.248 0c0 7.775-6.33 14.102-14.107 14.102"
                        fill="#212121"
                    />
                    <path
                        d="M106.104 188.175c0-45.313 36.863-82.174 82.176-82.174 45.315 0 82.175 36.861 82.175 82.174 0 45.314-36.86 82.178-82.175 82.178-45.313 0-82.176-36.864-82.176-82.178z"
                        fill="#E69D54"
                    />
                    <path
                        d="M188.28 104.535c-46.199 0-83.642 37.447-83.642 83.64 0 46.201 37.443 83.645 83.642 83.645 46.194 0 83.641-37.444 83.641-83.645 0-46.193-37.447-83.64-83.641-83.64m0 2.93c44.506 0 80.708 36.207 80.708 80.71 0 44.504-36.202 80.712-80.708 80.712-44.505 0-80.712-36.208-80.712-80.712 0-44.503 36.207-80.71 80.712-80.71"
                        fill="#212121"
                        fillRule="nonzero"
                    />
                    <path
                        d="M143.425 150.14a9 9 0 1 1 0-18 9 9 0 0 1 0 18z"
                        fill="#905347"
                    />
                    <path
                        d="M143.425 133.64a7.52 7.52 0 1 1 .02 15.04 7.52 7.52 0 0 1-.02-15.04zm0-2.94c-5.77 0-10.448 4.677-10.45 10.447-.002 5.77 4.673 10.45 10.443 10.453 5.77.004 10.451-4.67 10.457-10.44a10.45 10.45 0 0 0-10.45-10.46z"
                        fill="#212121"
                        fillRule="nonzero"
                    />
                    <path
                        d="M112.035 191.73a7.47 7.47 0 1 1 0-14.94 7.47 7.47 0 0 1 0 14.94z"
                        fill="#905347"
                    />
                    <path
                        d="M112.035 178.27a6 6 0 1 1 0 12 6 6 0 0 1 0-12zm0-2.93a8.93 8.93 0 1 0 8.93 8.93 8.92 8.92 0 0 0-8.93-8.93z"
                        fill="#212121"
                        fillRule="nonzero"
                    />
                    <path
                        d="M197.915 253.2c-10.388 0-18.81-8.422-18.81-18.81 0-10.388 8.422-18.81 18.81-18.81 10.388 0 18.81 8.422 18.81 18.81-.006 10.386-8.424 18.804-18.81 18.81z"
                        fill="#905347"
                    />
                    <path
                        d="M197.915 217.04c9.582 0 17.35 7.768 17.35 17.35s-7.768 17.35-17.35 17.35-17.35-7.768-17.35-17.35c.011-9.578 7.772-17.339 17.35-17.35zm0-2.93a20.28 20.28 0 1 0 20.28 20.28c0-11.2-9.08-20.28-20.28-20.28z"
                        fill="#212121"
                        fillRule="nonzero"
                    />
                    <path
                        d="M139.035 242.33a13.38 13.38 0 1 1 13.37-13.38c-.006 7.383-5.987 13.369-13.37 13.38z"
                        fill="#905347"
                    />
                    <path
                        d="M139.035 217.04c6.576.006 11.904 5.34 11.9 11.917-.004 6.576-5.337 11.905-11.913 11.903-6.577-.002-11.907-5.334-11.907-11.91.006-6.58 5.34-11.91 11.92-11.91zm0-2.93a14.84 14.84 0 1 0 14.83 14.84c-.006-8.19-6.64-14.829-14.83-14.84z"
                        fill="#212121"
                        fillRule="nonzero"
                    />
                    <path
                        d="M143.435 201.51a7.83 7.83 0 1 1 7.82-7.83 7.84 7.84 0 0 1-7.82 7.83z"
                        fill="#905347"
                    />
                    <path
                        d="M143.435 186.73a7 7 0 1 1 0 14 7 7 0 0 1 0-14zm0-1.72a8.69 8.69 0 1 0-.02 17.38 8.69 8.69 0 0 0 .02-17.38z"
                        fill="#212121"
                        fillRule="nonzero"
                    />
                    <path
                        d="M228.615 232.7a9.63 9.63 0 0 1 19.26 0 9.64 9.64 0 0 1-9.63 9.63 9.63 9.63 0 0 1-9.63-9.63z"
                        fill="#905347"
                    />
                    <path
                        d="M238.245 224.51a8.16 8.16 0 1 1 .02 16.32 8.16 8.16 0 0 1-.02-16.32zm0-2.94c-6.125 0-11.09 4.965-11.09 11.09s4.965 11.09 11.09 11.09 11.09-4.965 11.09-11.09c-.006-6.123-4.967-11.084-11.09-11.09z"
                        fill="#212121"
                        fillRule="nonzero"
                    />
                    <path
                        d="M266.625 201.83a5.18 5.18 0 1 1 5.18-5.18 5.17 5.17 0 0 1-5.18 5.18z"
                        fill="#905347"
                    />
                    <path
                        d="M266.625 192.94a3.72 3.72 0 1 1 .02 7.44 3.72 3.72 0 0 1-.02-7.44zm0-2.93a6.65 6.65 0 1 0 6.65 6.64 6.64 6.64 0 0 0-6.65-6.64z"
                        fill="#212121"
                        fillRule="nonzero"
                    />
                    <path
                        d="M228.405 133.99a10.08 10.08 0 1 1 10.07-10.08c-.005 5.56-4.51 10.069-10.07 10.08z"
                        fill="#905347"
                    />
                    <path
                        d="M228.405 115.31a8.61 8.61 0 1 1 0 17.22 8.61 8.61 0 0 1 0-17.22zm0-2.93a11.54 11.54 0 1 0 11.53 11.53c-.006-6.366-5.164-11.524-11.53-11.53z"
                        fill="#212121"
                        fillRule="nonzero"
                    />
                    <path
                        d="M196.455 144.81a9.63 9.63 0 1 1-.02-19.26 9.63 9.63 0 0 1 .02 19.26z"
                        fill="#905347"
                    />
                    <path
                        d="M196.455 127.03a8.16 8.16 0 1 1-8.16 8.16 8.17 8.17 0 0 1 8.16-8.16zm0-2.93a11.09 11.09 0 1 0 11.09 11.09c0-6.125-4.965-11.09-11.09-11.09z"
                        fill="#212121"
                        fillRule="nonzero"
                    />
                    <path
                        d="M240.865 176.17a7.83 7.83 0 1 1 7.83-7.83 7.84 7.84 0 0 1-7.83 7.83z"
                        fill="#905347"
                    />
                    <path
                        d="M240.725 161.22a7 7 0 1 1 0 14 7 7 0 0 1 0-14zm0-1.71a8.69 8.69 0 1 0 0 17.38 8.69 8.69 0 0 0 0-17.38z"
                        fill="#212121"
                        fillRule="nonzero"
                    />
                </g>
            </svg>
        );
    }
}

export default withStyles(styles, { withTheme: true })(CoffeeIcon);



// WEBPACK FOOTER //
// ./src/buy-me-a-coffee/CoffeeIcon.tsx